import { yup } from '@medely/ui-kit';

export const ehrSchema = yup.object().shape({
  ehr_systems: yup
    .array()
    .required('EHRs are required')
    .min(1, 'At least one EHR must be selected'),
});
